import { useState } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { downloadFollowUp } from 'services/results/follow-up'
import { canViewFollowUpComparison } from 'services/results/follow-up-access'
import { StrokedButton } from 'views/components/UI/Buttons'
import { useNotification } from 'lib/context/notification.context'

export default function ProcessReportsDownload({ processId, userId }: { processId: number; userId: number }) {
  const role = useSelector((state: any) => state.auth.role)
  const [busy, setBusy] = useState(false)
  const [unavailable, setUnavailable] = useState(false)
  const { getError } = useNotification()
  if (!canViewFollowUpComparison(role) || !processId || !userId) return null
  const download = async () => {
    if (busy || unavailable) return
    setBusy(true)
    try {
      await downloadFollowUp(
        processId,
        `participant/${userId}/reports.zip`,
        `Informes_Proceso_${processId}_Evaluado_${userId}.zip`
      )
    } catch (error: unknown) {
      if (axios.isAxiosError(error) && error.response?.status === 409) {
        setUnavailable(true)
        getError('El ZIP no está disponible: falta al menos un informe de este proceso.')
      } else {
        getError('No se pudieron descargar los informes. Comprueba tu acceso al proceso.')
      }
    } finally {
      setBusy(false)
    }
  }
  return (
    <span title={unavailable ? 'Falta al menos un informe de este proceso' : 'ZIP con informes completados y comparativos disponibles de este evaluado en el proceso'}>
      <StrokedButton disabled={busy || unavailable} aria-busy={busy} onClick={download}>
        {busy ? 'Preparando informes…' : unavailable ? 'Informes no disponibles' : 'Descargar los Informes'}
      </StrokedButton>
    </span>
  )
}
